import { useEffect, useState } from 'react';

import {
  useCheckNumberOfLeafsQuery,
  useDeleteAssignmentMutation,
  useDeleteTeachingStructureLeafMutation,
} from '@school_ify/schoolify-repository/src/teacher/types';

import useRouterHelper from 'hooks/useRouterHelper';

import IStudyQuery from '../../../../IURLQuery';

import './delete.scoped.scss';
import DeleteModal from 'components/DeleteModal/DeleteModal';
import { useAppSelector } from 'redux/hooks';
import { studyDetailsState } from 'redux/study/studyDetails.slice';

import { useTranslation } from 'react-i18next';

const Delete = ({ callback, handleModal, deleteModal }) => {
  const [numberOfLeafs, setNumberOfLeafs] = useState<number>(0);
  const [deleteAssignmentMutation] = useDeleteAssignmentMutation();
  const [deleteTeachingStructureLeafMutation] = useDeleteTeachingStructureLeafMutation();
  const { activeChapter, chapterAssignmentsLength, leafs } = useAppSelector(studyDetailsState);
  const { t } = useTranslation();

  const { query, routePush } = useRouterHelper<IStudyQuery>();

  const { data: numberOfLeafsData, loading: numberOfLeafsLoading } = useCheckNumberOfLeafsQuery({
    variables: {
      id: query.lesson as string,
    },
  });

  const deleteAssignment = async () => {
    await deleteAssignmentMutation({
      variables: {
        id: query.lesson as string,
      },
    });
  };

  const deleteTeachinStructureItem = async () => {
    if (numberOfLeafs > 1) {
      return null;
    }
    deleteTeachingStructureLeafMutation({
      variables: {
        id: query.lesson as string,
      },
      onCompleted() {
        callback();
      },
    });
  };

  const handleDeleteConfirmation = async () => {
    if (!query && query.type) {
      return;
    }
    switch (query?.type) {
      case 'structure':
        await deleteTeachinStructureItem();
        break;
      default:
        await deleteAssignment();
        break;
    }

    handleModal();
    routePush({
      removeSearch: ['lesson'],
    });
    callback();
  };

  const handleLeaf = () => {
    if (numberOfLeafsLoading) {
      return null;
    }
    if (!numberOfLeafsData) {
      return null;
    }
    if (numberOfLeafsData?.teaching_structures_by_pk === null) {
      return null;
    }
    const rtl = numberOfLeafsData?.teaching_structures_by_pk?.rtl;
    const ltr = numberOfLeafsData?.teaching_structures_by_pk?.ltr;
    setNumberOfLeafs(rtl - ltr);
  };

  useEffect(() => {
    handleLeaf();
  }, [numberOfLeafsLoading]);

  const dontHaveChild = leafs <= 1 && chapterAssignmentsLength === 0;
  const typeStructure = query.type !== 'structure';

  return (
    <DeleteModal
      openModal={deleteModal}
      handleModal={() => handleModal()}
      generalMessage={
        dontHaveChild || typeStructure ? activeChapter : t('common:study_cannot_delete')
      }
      shouldRenderFooter={dontHaveChild || typeStructure}
      shouldRenderAreYouSure={dontHaveChild || typeStructure}
      handleCloseModal={() => handleModal()}
      handleDelete={handleDeleteConfirmation}
      numberOfLeafs={numberOfLeafs}
      type={query.type}
      chapterAssignmentsLength={chapterAssignmentsLength}
    />
  );
};
export default Delete;
